import { render } from "./reset-password-dialog.vue?vue&type=template&id=468d8792&scoped=true"
import script from "./reset-password-dialog.vue?vue&type=script&lang=js"
export * from "./reset-password-dialog.vue?vue&type=script&lang=js"

import "./reset-password-dialog.vue?vue&type=style&index=0&id=468d8792&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468d8792"]])

export default __exports__